/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Group from 'material/group/group';
// import Copy from 'material/copy/copy';
// import Title from 'material/copy/title/title';
// import PaymentInfoCTAs from 'pages/dashboard/account/paymentinfo/paymentInfoCTAs/paymentInfoCTAs_container';
// states
import LoadState from 'material/states/load/load';
import EmptyState from 'material/states/empty/empty';
// pages
import SelectMethod from 'pages/dashboard/account/paymentinfo/selectmethod/selectmethod_container';
import EnterInformation from 'pages/dashboard/account/paymentinfo/enterinformation/enterinformation_container';
import ExistingPayments from 'pages/dashboard/account/paymentinfo/existingpayments/existingpayments_container';
// utils
import {Route, Redirect, Switch} from 'react-router';
import { PrivateRoute } from 'utils/privateRoute';
// styles
import injectSheet from 'react-jss';
import styles from 'pages/dashboard/account/paymentinfo/paymentinfo_styles';



/* ========== ~~~~~~~~~~ PAYMENT INFO : PAGE ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class PaymentInfo extends Component {
    constructor(props){
        super(props);
        this.state = {
            file: ''
        }
    }

    componentDidMount() {
        this.props.getPaymentInformation(this.props.accountUUID);
    }
    componentWillUnmount(){
        this.handleDiscard();
    }
    handleFileUpload = (file) => {
        this.setState({file})
    };
    handleDiscardFile = () => {
        this.setState({file: ''})
    };
    handleDiscard = () => {
        this.props.discardChanges(this.props.formName);
        this.props.setFormEditableState(this.props.formName, false)
    };

    handleAddPayment = () => {
       this.props.moveToPage('dashboard/account/paymentinfo/selectmethod')
    };

    _getPermittedPath = () => !this.props.savedPaymentTypes.length ? '/dashboard/account/paymentinfo/emptystate' : '/dashboard/account/paymentinfo/existingpayments';
    render() {
        if(this.props.permissions.length < 1) return null; // Waits for permissions.
        return(
            <div className={`paymentinfo ${this.props.classes.paymentinfo}`}>
                <Group name={`page-details`}>
                    {!this.props.paymentInfoReceived ?
                        <LoadState
                        graphicName={`payment`}
                        graphicText={`Check and Credit Cards`}
                        bodycopy={`We're fetching your payment information.`}
                        /> :
                    <Switch>
                        <Route exact path='/dashboard/account/paymentinfo' render={() => <Redirect to={this._getPermittedPath()} />} />
                        <PrivateRoute permitted={this.props.paymentInfoPermitted} path='/dashboard/account/paymentinfo/emptystate'
                                      graphicName={`payment`}
                                      graphicText={`Check and Credit Cards`}
                                      bodycopy={`You have no registered payment methods. Add one to receive payments from Insticator.`}
                                      buttonName={`addpayment`}
                                      buttonText={`Add Payment Method`}
                                      buttonClick={this.handleAddPayment} component={EmptyState}/>
                        <PrivateRoute permitted={this.props.paymentInfoPermitted} path={'/dashboard/account/paymentinfo/selectmethod'} component={SelectMethod} />
                        <PrivateRoute permitted={this.props.paymentInfoPermitted && this.props.selectedPaymentType!=='NONE'} path='/dashboard/account/paymentinfo/enterinformation' redirectTo={'/dashboard/account/paymentinfo'} handleFileUpload={this.handleFileUpload} handleFileDiscard={this.handleDiscardFile} component={EnterInformation} />
                        <PrivateRoute permitted={this.props.paymentInfoPermitted && this.props.savedPaymentTypes.length>0} path={'/dashboard/account/paymentinfo/existingpayments'} redirectTo={'/dashboard/account/paymentinfo/selectmethod'}  component={ExistingPayments} />
                        <Redirect to='/error/404' />
                    </Switch>}
                </Group>
            </div>
        );
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(PaymentInfo);